import { CapoPlugin } from "/codebuild/output/src1732550827/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];